import { checkForRewards } from "../rewards/checkForRewards";

export async function checkCodes(enteredCode, sid, mainLanguageCode, customerNo, shopCode, company,groupCode,groupName,lotteryToConfirm,lotteryIsConfirmed) {
    const params = new URLSearchParams();
    params.set("sid", sid);
    params.set("site_language", mainLanguageCode);
    params.set("customer_no", customerNo);
    params.set("shop_code", shopCode);
    params.set("company", company);
    params.set("input_fk_code", enteredCode);
    params.set("group_code", groupCode);
    params.set("group_name", groupName);

    if (lotteryToConfirm) {
        params.set("lottery_to_confirm", lotteryToConfirm);
        params.set("lottery_is_confirmed", lotteryIsConfirmed);
    }

    if(groupCode && groupName) {
        params.set("function", "checkCodeGroup");
    }else{
        params.set("function", "checkCodeSingle");
    }
    const checkButton=document.querySelector(".js-check-manual-form-submit");
    const pointsStatusIcon=document.getElementById("resulticon_"+enteredCode)
    const resultItem=document.getElementById("result_"+enteredCode)
    resultItem.classList.add("loading");
    pointsStatusIcon.setAttribute("data-original-title","");
    pointsStatusIcon.classList.add("loading");

    let amount=0;
    try {
        const response = await fetch("/module/mysydeshop/b2c/ajax.php", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: params.toString(),
        });

        if (!response.ok) throw new Error("Network error");

        const data = await response.json();
        const iconColor = data.status;
        amount = data?.amount ?? 0;
        const text = data.message;

        if (iconColor === "color-green") {
            resultItem.remove();

            pointsStatusIcon.classList.add("success");
            resultItem.classList.add("success");
            resultItem.classList.remove("loading");
            pointsStatusIcon.classList.remove("loading");
            pointsStatusIcon.setAttribute("data-original-title",text);




            const widgetEl = document.querySelector("#lotteryDashboardWidget");

            if (widgetEl && data?.lottery?.lottery_widget) {
                widgetEl.outerHTML = data.lottery.lottery_widget;
            }

            if (data?.lottery?.ticket_created) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: "einloesungLos" });
            }

            if (data.lottery && data.lottery.is_instant) {
                const instantModalText = document.getElementById("header_instant_win_modal_text");
                if (instantModalText) instantModalText.innerHTML = data.lottery.html;

                const instantModal = document.getElementById("header_instant_win_modal");
                if (instantModal) $(instantModal).modal("show");

                $("#button_instant_retrieve").one("click", async function () {
                    const instantParams = new URLSearchParams($("#form_instant_selection").serialize());
                    instantParams.set("function", "retrieveInstantWin");
                    instantParams.set("sid", sid);
                    instantParams.set("site_language", mainLanguageCode);
                    instantParams.set("customer_no", customerNo);
                    instantParams.set("shop_code", shopCode);
                    instantParams.set("company", company);
                    instantParams.set("input_fk_code", enteredCode);

                    try {
                        const instantRes = await fetch("/module/mysydeshop/b2c/ajax.php", {
                            method: "POST",
                            headers: { "Content-Type": "application/x-www-form-urlencoded" },
                            body: instantParams.toString(),
                        });

                        const instantData = await instantRes.json();

                        if (!instantData.status) {
                            const errorText = document.getElementById("header_instant_win_modal_error_text");
                            if (errorText) errorText.innerHTML = instantData.html;

                            const errorModal = document.getElementById("header_instant_win_modal_error");
                            if (errorModal) {
                                $(errorModal).modal("show");
                                setTimeout(() => $(errorModal).modal("hide"), 2000);
                            }
                        }
                    } catch (err) {
                        console.error("Instant win fetch error:", err);
                    }

                    if (instantModal) $(instantModal).modal("show");
                });
            }
            setTimeout(() => {
                if (typeof checkIcon !== "undefined") checkIcon.className = "input-group-addon";
                if (iconColor === "color-green" && typeof inputElt !== "undefined") inputElt.value = "";
            }, 2000);
            [5, 6, 7, 9, 10].forEach(checkForRewards);
            return amount;

        } else {
            resultItem.classList.remove("loading");
            pointsStatusIcon.classList.remove("loading");
            pointsStatusIcon.classList.add("error");
            resultItem.classList.add("error");
            checkButton.style.removeProperty("display");
            pointsStatusIcon.setAttribute("data-original-title",text);

            return amount;
        }


    } catch (err) {
        pointsStatusIcon.classList.add("error");
        pointsStatusIcon.classList.remove("error");
        resultItem.classList.add("error");

        checkButton.style.removeProperty("display");
        resultItem.classList.remove("loading");

        pointsStatusIcon.setAttribute("data-original-title","Error checking codes");

        console.error("Error checking codes:", err);
        return amount;
    }
}
